import ProductDetailsPageHeader from "./ProductDetailsPageHeader";
import ProductDetailsForm from "./ProductDetailsForm";

export { ProductDetailsPageHeader, ProductDetailsForm };
